import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { AccountAction } from './types';
import { AccountSlice } from '../types';
import { INITIAL_ACCOUNT_STATE } from '../const';
import { updateAccountState } from './utils/updateAccountState';

export const initialState: AccountSlice = {};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setTeamAccountAddress: (
      state,
      action: AccountAction<'teamAccountAddress'>,
    ) => {
      updateAccountState({ action, state });
    },
    setIsAccountPremissionDialogHidden: (
      state,
      action: AccountAction<'isAccountPermissionDialogHidden'>,
    ) => {
      updateAccountState({ action, state });
    },
    setIsTeamAccountInitialized: (
      state,
      action: AccountAction<'isTeamAccountInitialized'>,
    ) => {
      updateAccountState({ action, state });
    },
    setIsWorkerAuthorized: (
      state,
      action: AccountAction<'isWorkerAuthorized'>,
    ) => {
      updateAccountState({ action, state });
    },
    setUserEndpointToken: (
      state,
      action: AccountAction<'userEndpointToken'>,
    ) => {
      updateAccountState({ action, state });
    },
    setWorkerToken: (state, action: AccountAction<'workerToken'>) => {
      updateAccountState({ action, state });
    },
    resetAccountState: (state, action: PayloadAction<string>) => {
      const authAddress = action.payload.toLowerCase();
      const teamAccountAddress = state[authAddress].teamAccountAddress;

      state[authAddress] = {
        ...INITIAL_ACCOUNT_STATE,
        teamAccountAddress,
      };
    },
  },
});

export const {
  resetAccountState,
  setIsAccountPremissionDialogHidden,
  setIsTeamAccountInitialized,
  setIsWorkerAuthorized,
  setTeamAccountAddress,
  setUserEndpointToken,
  setWorkerToken,
} = accountSlice.actions;
